
import AppWeekprogramsIndex from "./weekProgram.vue";
import AppWeekprogramsList from "./list/list.vue";
import AppWeekprogramsItem from "./item/item.vue";

const routes = [
  {
    path: "weekProgram",
    component: AppWeekprogramsIndex,
    meta: {
      auth: {
        roles: "weekProgram.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "weekProgram.index",
        component: AppWeekprogramsList,
        meta: {
          auth: {
            roles: "weekProgram.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "weekProgram.create",
        component: AppWeekprogramsItem,
        meta: {
          auth: {
            roles: "weekProgram.create",
            redirect: { name: "weekProgram.index" }
          }
        }
      },
      {
        path: ":id",
        name: "weekProgram.edit",
        component: AppWeekprogramsItem,
        meta: {
          auth: {
            roles: "weekProgram.update",
            redirect: { name: "weekProgram.index" }
          }
        }
      }
    ]
  }
];

export default routes;
